import {
  teleportVoiceCommandList,
  actionsPromptOptionsExpression,
} from '@core/assistant/voiceCommand';

export const processActionsAudioPrompt = (text: string) => {
  const actionTypes = [
    actionsPromptOptionsExpression,
    teleportVoiceCommandList,
  ];
  let match = '';

  for (let a = 0; a < actionTypes.length; a++) {
    const actions = actionTypes[a];

    for (let i = 0; i < actions.length; i++) {
      const partial = actions[i].split(' ');
      const occurencies = [];

      for (let j = 0; j < partial.length; j++) {
        if (text.indexOf(partial[j]) > -1) {
          occurencies.push(partial[j]);
        }
      }

      if (occurencies.join(' ') === actions[i]) {
        match = actions[i];
      }
    }
  }

  return match;
};
